<template>
  <span>
    <slot v-if="allowed"></slot>
    <slot name="notAllowed" v-else></slot>
  </span>
</template>

<script>
import FeatureFlagsMixin from "../../mixins/FeatureFlagsMixin.vue";

export default {
  mixins: [FeatureFlagsMixin],

  components: {},

  props: {
    feature: String,
  },

  data() {
    return {
      allowed: false,
    };
  },

  methods: {},

  computed: {},

  async created() {
    if (!this.feature) {
      this.allowed = false;
      return;
    }

    this.allowed = await this.checkFeature(this.feature);
  },
};
</script>
